import Link from "next/link"
import styles from "../../styles/components/blogs/BlogCard.module.css"
import { replaceImageUrl } from "../../utils/helpers/imageUtils"
import { formatDate } from "../../utils/helpers/utils"
import { OptimizedImage } from "../common"

export default function BlogCard({ blog, hideAuthor = false, isFirstCard = false }) {
  if (!blog) return null

  

  const getExcerpt = (content, maxLength = 150) => {
    if (!content) return ""
    const text = content.replace(/<[^>]*>/g, "") // Remove HTML tags
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text
  }

  const getCategoryNames = (categories) => {
    if (!categories || categories.length === 0) return ["Uncategorized"]
    const validCategories = categories.map((cat) => cat.name).filter((name) => name && name !== "Uncategorized")
    return validCategories.length > 0 ? validCategories : ["Uncategorized"]
  }



  return (
    <article className={styles.blogCard}>
        <div className={styles.imageContainer}>
          {blog.thumbnail?.url ? (
            <Link href={`/blog/${blog.slug}`} className={styles.cardLink}>
              <OptimizedImage
                src={replaceImageUrl(blog.thumbnail.url) || "/placeholder.svg"}
                alt={blog.thumbnail.alternativeText || blog.title}
                width={400}
                height={250}
                className={styles.blogImage}
                sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw"
                priority={isFirstCard}
                quality={75}
                placeholder="blur"
                blurDataURL="/placeholder.svg"
                objectFit="cover"
              />
            </Link>
          ) : (
            <div className={styles.placeholderImage}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21,15 16,10 5,21" />
              </svg>
            </div>
          )}

          <div className={styles.categoryBadges}>
            {getCategoryNames(blog.categories).slice(0, 2).map((category, index) => (
              <span key={index} className={styles.categoryBadge}>
                {category}
              </span>
            ))}
            {getCategoryNames(blog.categories).length > 2 && (
              <span className={styles.categoryBadge}>
                +{getCategoryNames(blog.categories).length - 2}
              </span>
            )}
          </div>
        </div>

        <div className={styles.cardContent}>
          <Link href={`/blog/${blog.slug}`} className={styles.cardLink}>
            <h2 className={styles.blogTitle}>{blog.title}</h2>
          </Link>

          {blog.Description && <p className={styles.blogExcerpt}>{getExcerpt(blog.Description)}</p>}

          <div className={styles.metaInfo}>
              {!hideAuthor && (
            <div className={styles.metaSection}>
                <div className={styles.authorSection}>
                  {blog.author?.image?.url && (
                   <OptimizedImage
                   src={replaceImageUrl(blog?.author?.image?.url || blog?.Author?.image?.url) || "/placeholder.svg"}
                   alt={blog?.author?.image?.alternativeText || blog?.Author?.image?.alternativeText || blog?.author?.name || blog?.Author?.name}
                   width={24}
                   height={24}
                   className={styles.authorImage}
                   loading="lazy"
                   quality={60} // Lower quality to save bytes
                   sizes="24px" // Tells Next.js this image only needs to be 24px wide
                 />
                 
                  )}
                  {blog.author?.slug ? (
                    <Link href={`/author/${blog.author.slug}`} className={styles.authorName}>
                      {blog.author.name}
                    </Link>
                  ) : (
                    <span className={styles.authorName}>{blog.author?.name || blog.Author?.name}</span>
                  )}
                </div>
            </div>
              )}

            {!hideAuthor && <span className={styles.separator}>|</span>}

            <div className={styles.metaSection}>
              <div className={styles.dateSection}>
                <svg
                  className={styles.metaIcon}
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <time className={styles.publishDate}>{formatDate(blog.Date || blog.publishedAt || blog.createdAt)}</time>
              </div>
            </div>

            <span className={styles.separator}>|</span>

            <div className={styles.metaSection}>
              {blog.ReadTime && (
                <div className={styles.readTimeSection}>
                  <svg
                    className={styles.metaIcon}
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12,6 12,12 16,14"></polyline>
                  </svg>
                  <span className={styles.readTime}>{blog.ReadTime} Minute</span>
                </div>
              )}
            </div>
          </div>
        </div>
      

      {/* just add link of authors page here and make it hidden , just want to only show so that page is not showing as orphan page */}
      <Link href="/authors" className={styles.authorsLink}>
        <span className={styles.authorsLinkText}>View All Authors</span>
      </Link>
    </article>
  )
}